"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildOptions = exports.ChartTooltipFormatterFn = exports.SharedChartTooltipFormatterFn = exports.getTooltipRow = exports.tooltipOptions = void 0;
/** @jsx jsx */
var react_1 = require("@emotion/react");
var constants_1 = require("./constants");
var style_1 = require("../../../style");
var server_1 = __importDefault(require("react-dom/server"));
var ChartTooltip_1 = __importDefault(require("./shared/components/ChartTooltip"));
var SharedChartToolip_1 = __importDefault(require("./shared/components/SharedChartTooltip/SharedChartToolip"));
var design_system_theme_1 = __importDefault(require("../../../style/theme/design-system-theme"));
exports.tooltipOptions = {
    backgroundColor: 'none',
    padding: 0,
    borderWidth: 0,
    borderRadius: 0,
    shadow: false,
};
function getTooltipRow() {
    var _a;
    var tooltipRows = (_a = this === null || this === void 0 ? void 0 : this.points) === null || _a === void 0 ? void 0 : _a.map(function (point) { return ({
        key: point.key,
        color: point.color.toString(),
        label: point.series.name,
        value: point.y,
    }); });
    return tooltipRows;
}
exports.getTooltipRow = getTooltipRow;
function SharedChartTooltipFormatterFn(label, rows, subText, customTooltipRowValueFn) {
    return server_1.default.renderToString(react_1.jsx(style_1.ThemeProvider, { theme: design_system_theme_1.default, nonce: window.__CSP_NONCE__ },
        react_1.jsx(SharedChartToolip_1.default, { customTooltipRowValueFn: customTooltipRowValueFn, label: label, rows: rows, subtext: subText })));
}
exports.SharedChartTooltipFormatterFn = SharedChartTooltipFormatterFn;
var ChartTooltipFormatterFn = function (color, label, value, after, customTooltipRowValueFn) {
    return server_1.default.renderToString(react_1.jsx(style_1.ThemeProvider, { theme: design_system_theme_1.default, nonce: window.__CSP_NONCE__ },
        react_1.jsx(ChartTooltip_1.default, { customTooltipRowValueFn: customTooltipRowValueFn, color: color, label: label, value: value, after: after })));
};
exports.ChartTooltipFormatterFn = ChartTooltipFormatterFn;
var buildOptions = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, width = _a.width, height = _a.height, margin = _a.margin, marginTop = _a.marginTop, marginRight = _a.marginRight, marginBottom = _a.marginBottom, marginLeft = _a.marginLeft, xAxisTitle = _a.xAxisTitle, yAxisTitle = _a.yAxisTitle, hideXaxis = _a.hideXaxis, hideYaxis = _a.hideYaxis, showXAxisGridline = _a.showXAxisGridline, showYAxisGridline = _a.showYAxisGridline, xAxisLabelFormatter = _a.xAxisLabelFormatter, yAxisLabelFormatter = _a.yAxisLabelFormatter, xAxisLabelRotation = _a.xAxisLabelRotation, yAxisLabelRotation = _a.yAxisLabelRotation, xAxisPlotLines = _a.xAxisPlotLines, yAxisPlotLines = _a.yAxisPlotLines, xAxisPlotBands = _a.xAxisPlotBands, yAxisPlotBands = _a.yAxisPlotBands, legendFormatter = _a.legendFormatter, tooltipFormatter = _a.tooltipFormatter, _b = _a.enableLegend, enableLegend = _b === void 0 ? true : _b, _c = _a.sharedTooltip, sharedTooltip = _c === void 0 ? false : _c, additionalYAxes = _a.additionalYAxes, yAxisLineWidth = _a.yAxisLineWidth, xAxisLineWidth = _a.xAxisLineWidth, _d = _a.legendVerticalAlign, legendVerticalAlign = _d === void 0 ? 'bottom' : _d, legendHorizontalAlign = _a.legendHorizontalAlign, legendLayout = _a.legendLayout, _e = _a.legendItemMarginBottom, legendItemMarginBottom = _e === void 0 ? 8 : _e, legendItemWidth = _a.legendItemWidth, scrollablePlotArea = _a.scrollablePlotArea, legendWidth = _a.legendWidth;
    var optionsMap = {
        chart: {
            width: width,
            height: height,
            margin: margin,
            marginTop: marginTop,
            marginRight: marginRight,
            marginBottom: marginBottom,
            marginLeft: marginLeft,
            scrollablePlotArea: scrollablePlotArea,
        },
        colors: constants_1.CHART_COLORS,
        title: title ? { text: title, useHTML: true, align: 'left' } : undefined,
        subtitle: subtitle ? { text: subtitle, useHTML: true, align: 'left' } : undefined,
        xAxis: {
            visible: !hideXaxis,
            lineWidth: xAxisLineWidth,
            gridLineWidth: showXAxisGridline ? 1 : 0,
            title: {
                text: xAxisTitle,
            },
            labels: {
                useHTML: !!xAxisLabelFormatter,
                rotation: xAxisLabelRotation,
                formatter: xAxisLabelFormatter,
                style: !xAxisLabelFormatter
                    ? {
                        color: style_1.DesignSystemThemeColor.Gray.DARK_1,
                    }
                    : {},
            },
            plotLines: xAxisPlotLines,
            plotBands: xAxisPlotBands,
        },
        yAxis: {
            reversedStacks: false,
            visible: !hideYaxis,
            lineWidth: yAxisLineWidth,
            gridLineWidth: showYAxisGridline ? 1 : 0,
            title: {
                text: yAxisTitle,
            },
            labels: {
                useHTML: !!yAxisLabelFormatter,
                rotation: yAxisLabelRotation,
                formatter: yAxisLabelFormatter,
                style: !yAxisLabelFormatter
                    ? {
                        color: style_1.DesignSystemThemeColor.Gray.DARK_1,
                    }
                    : {},
            },
            plotLines: yAxisPlotLines,
            plotBands: yAxisPlotBands,
        },
        credits: {
            enabled: false,
        },
        tooltip: __assign(__assign({}, exports.tooltipOptions), { shared: sharedTooltip, useHTML: !!tooltipFormatter, formatter: tooltipFormatter }),
        legend: __assign({ width: legendWidth, enabled: enableLegend, verticalAlign: legendVerticalAlign, align: legendHorizontalAlign, layout: legendLayout, itemMarginBottom: legendItemMarginBottom, itemWidth: legendItemWidth }, (legendFormatter ? {
            useHTML: true,
            labelFormatter: function formatLegend() {
                return legendFormatter(this);
            },
        } : {})),
        exporting: {
            enabled: false,
        },
    };
    if (additionalYAxes && additionalYAxes.length > 0) {
        optionsMap.yAxis = __spreadArrays([optionsMap.yAxis], additionalYAxes);
    }
    return optionsMap;
};
exports.buildOptions = buildOptions;
